import { Dispatch, AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

import ShopifyClient from "lib/ShopifyClient";

import { LineItems } from "types";

export const fetchOrCreateCheckout = (checkoutId: string) => (
  dispatch: ThunkDispatch<{}, {}, AnyAction>
) => ({
  type: "FETCH_OR_CREATE_CHECKOUT",
  payload: new Promise(resolve => {
    if (!checkoutId) {
      return dispatch(createCheckout());
    }

    return dispatch(fetchCheckout(checkoutId));
  })
});

export const createCheckout = () => ({
  type: "CREATE_CHECKOUT",
  payload: new Promise(resolve => {
    return ShopifyClient.createCheckout().then(checkout => {
      return resolve(checkout);
    });
  })
});

export const fetchCheckout = (checkoutId: string) => (dispatch: Dispatch) =>
  dispatch({
    type: "FETCH_CHECKOUT",
    payload: new Promise((resolve, reject) =>
      ShopifyClient.fetchCheckout(checkoutId)
        .then(res => {
          if (res.checkout.completedAt) {
            dispatch(createCheckout());
          }

          return resolve(res);
        })
        .catch(data => {
          reject(data);
          dispatch(createCheckout());
        })
    )
  });

export const updateLineItems = (checkoutId: string, lineItems: LineItems) => (
  dispatch: Dispatch
) =>
  dispatch({
    type: "UPDATE_LINE_ITEMS",
    payload: new Promise((resolve, reject) => {
      return ShopifyClient.updateCheckout(checkoutId, lineItems)
        .then(checkout => {
          resolve(checkout);
        })
        .catch(data => {
          reject(data);
          dispatch(createCheckout());
        });
    })
  });
